export interface ReportingUser {
  id: string;
  externalId: string;
  authProvider: string;
  userName: string;
  emailAddress?: string;
  firstName?: string;
  lastName?: string;
  title?: string;
  createdAt?: Date;
  lastLogin?: Date;
  roles: ReportingRole[];
  roleEntity?: string;
  isSystem: boolean;
  role: ReportingRole;
  settings: ReportingUserSettings;
}

export interface ReportingRole {
  name: string;
  permissions: ReportingPermission[];
}

export interface ReportingPermission {
  name: string;
  category: string;
}

export interface ReportingUserSettings {
  locale: string;
  theme: string;
  timeZone: string;
}
